"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_sdk_1 = require("@subhubapps/store-sdk");
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var react_query_1 = require("react-query");
function Referrals(_a) {
    var _this = this;
    var customerId = _a.customerId;
    var referralSettings = window.referralsApp;
    var _b = __read(React.useState(false), 2), isCopied = _b[0], setIsCopied = _b[1];
    var subhubClient = new store_sdk_1.Referral(referralSettings.subhubAccountUUID || '', referralSettings.ambassadorPortalUrl || '');
    var query = (0, react_query_1.useQuery)(['referrals', referralSettings.subhubCustomerUUID], function () {
        return subhubClient.getCustomerReferralInfo(referralSettings.subhubCustomerUUID);
    });
    var copyCode = function (text) { return __awaiter(_this, void 0, void 0, function () {
        var el;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!text)
                        return [2 /*return*/];
                    if (!('clipboard' in navigator)) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    el = document.createElement('textarea');
                    el.value = text;
                    document.body.appendChild(el);
                    el.select();
                    document.execCommand('copy');
                    document.body.removeChild(el);
                    _a.label = 3;
                case 3:
                    setIsCopied(true);
                    setTimeout(function () {
                        setIsCopied(false);
                    }, 2000);
                    return [2 /*return*/];
            }
        });
    }); };
    var ambassadorInfo = query.data;
    if (!customerId)
        return null;
    if (!(referralSettings === null || referralSettings === void 0 ? void 0 : referralSettings.subhubAccountUUID) || !(referralSettings === null || referralSettings === void 0 ? void 0 : referralSettings.ambassadorPortalUrl))
        return null;
    var unpaidBalance = (ambassadorInfo === null || ambassadorInfo === void 0 ? void 0 : ambassadorInfo.unpaidBalance) || 0;
    return (React.createElement("div", { className: 'padding-vertical-3' },
        React.createElement("div", { className: 'padding-vertical-5 account-container padding-horizontal-5 bg-white bordered border-very-light-pink ' },
            React.createElement("div", { className: ' grid-x' },
                React.createElement("div", { className: 'cell small-8 text-left font-size-14' }, "Referrals")),
            React.createElement("div", { className: 'bundle-item-block margin-bottom-4 font-size-12' },
                React.createElement("a", { className: 'button btn small hollow margin-right-2 margin-left-2 float-right', target: '_blank', href: referralSettings.subhubCustomerUUID
                        ? subhubClient.getCustomerLoginUrl(referralSettings.customerId.toString(), referralSettings.subhubCustomerUUID)
                        : subhubClient.getCustomerSignupUrl(referralSettings.customerId.toString()) }, (function () {
                    if (!referralSettings.subhubCustomerUUID)
                        return 'Sign Up';
                    if (unpaidBalance > 0)
                        return 'Redeem';
                    return 'View More';
                })()),
                React.createElement("div", { className: 'margin-top-3' },
                    (function () {
                        if (unpaidBalance > 0)
                            return "Way to go! \uD83D\uDE4C You have $".concat((0, currency_js_1.default)(unpaidBalance).toString(), " in CASH available.");
                        if (unpaidBalance <= 0)
                            return "You're ready to earn cash for sharing Hello Bello!";
                        return "Earn cash for sharing Hello Bello! Free diapers? Yes, please. \uD83D\uDE4F";
                    })(),
                    React.createElement("div", { className: 'margin-top-3 text-gray' },
                        (function () {
                            if (unpaidBalance > 0 && ambassadorInfo)
                                return "Keep it up! Every time a new customer uses your link on their first order, they get ".concat(ambassadorInfo.discountAmount, "% off and you earn ").concat(ambassadorInfo.commissionAmount, "% of their order total!");
                            if (unpaidBalance <= 0 && ambassadorInfo)
                                return "Give friends & family ".concat(ambassadorInfo.discountAmount, "% off with your personal link. Earn ").concat(ambassadorInfo.commissionAmount, "% of each new customer's first order! ");
                            return "Give friends & family 20% off with your personal link. Earn 10% of each new customer's first order! ";
                        })(),
                        ambassadorInfo && (React.createElement(React.Fragment, null,
                            React.createElement("br", null),
                            React.createElement("button", { className: 'text-underline', onClick: function () { return copyCode(ambassadorInfo.discountCodeApplicationUrl); } }, isCopied ? 'Copied' : 'Copy & Share your unique link')))))))));
}
exports.default = Referrals;
